import { useUpdateOppStatus } from '@user/components/Opportunities/hooks'
import { useSelectOppStages } from '@user/store/salesFunnel'
import { ChangeEvent, useCallback, useState } from 'react'
import { Props } from '../OpportunityStatusSelect'

export function useHandlers(props: Props) {
  const { salesFunnelId, opportunityId } = props

  const [salesFunnelStages, closedWonStageId, closedLostStageId] =
    useSelectOppStages(salesFunnelId)

  const { loading, onCloseWin, onChangeStatus, closeActiveDialog } =
    useUpdateOppStatus(opportunityId, closedWonStageId, closedLostStageId)

  const [anchorEl, setAnchorEl] = useState<Element | null>(null)
  const wonLostMenuOpen = Boolean(anchorEl)

  const handleClosedWonMenuItemClick = useCallback(() => {
    onChangeStatus(closedWonStageId)
    setAnchorEl(null)
  }, [closedWonStageId, onChangeStatus])

  const handleClosedLostMenuItemClick = useCallback(() => {
    onChangeStatus(closedLostStageId)
    setAnchorEl(null)
  }, [closedLostStageId, onChangeStatus])

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      if (typeof value === 'number') onChangeStatus(value)
    },
    [onChangeStatus],
  )

  return {
    anchorEl,
    handleClosedWonMenuItemClick,
    handleClosedLostMenuItemClick,
    onChange,
    loading,
    onCloseWin,
    onChangeStatus,
    closeActiveDialog,
    salesFunnelStages,
    setAnchorEl,
    wonLostMenuOpen,
  }
}
